import { Layout } from "@/components/layout/Layout";
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import { ArrowRight, Clock, Mail, MapPin, Bus, Train, Car, Phone } from "lucide-react";

const orari = [
  { giorno: "Lunedì", bambini: "17:30 - 18:30", adulti: "18:30 - 20:00" },
  { giorno: "Martedì", bambini: "—", adulti: "—" },
  { giorno: "Mercoledì", bambini: "17:30 - 18:30", adulti: "18:30 - 20:00" },
  { giorno: "Giovedì", bambini: "—", adulti: "—" },
  { giorno: "Venerdì", bambini: "17:30 - 18:30", adulti: "18:30 - 20:00" },
  { giorno: "Sabato", bambini: "Chiuso", adulti: "Chiuso" },
  { giorno: "Domenica", bambini: "Chiuso", adulti: "Chiuso" },
];

const Contatti = () => {
  return (
    <Layout>
      <Helmet>
        <title>Contatti e Orari - Taekwondo Mattei Roma</title>
        <meta name="description" content="Contatti, orari dei corsi e indicazioni per raggiungere Taekwondo Mattei in Via Marino Mazzacurati 90, Roma." />
        <link rel="canonical" href="https://taekwondomattei.com/contatti" />
        <meta property="og:title" content="Contatti e Orari - Taekwondo Mattei Roma" />
        <meta property="og:description" content="Contatti, orari dei corsi e indicazioni per raggiungere Taekwondo Mattei in Via Marino Mazzacurati 90, Roma." />
        <meta property="og:image" content="https://taekwondomattei.com/og-home.jpg" />
        <meta property="og:url" content="https://taekwondomattei.com/contatti" />
        <meta property="og:type" content="website" />
        <meta property="og:locale" content="it_IT" />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="Contatti e Orari - Taekwondo Mattei Roma" />
        <meta name="twitter:description" content="Contatti, orari dei corsi e indicazioni per raggiungere Taekwondo Mattei in Via Marino Mazzacurati 90, Roma." />
        <meta name="twitter:image" content="https://taekwondomattei.com/og-home.jpg" />
      </Helmet>
      {/* Hero */}
      <section className="py-24 md:py-32 bg-secondary">
        <div className="container-wide mx-auto px-4 md:px-8">
          <div className="max-w-3xl">
            <h1 className="font-display text-4xl md:text-5xl lg:text-6xl font-bold text-foreground mb-6">
              Contatti
            </h1>
            <p className="font-body text-xl text-muted-foreground">
              Hai domande? Vuoi venire a trovarci? Siamo qui per aiutarti.
            </p>
          </div>
        </div>
      </section>

      {/* Contact Info + Map */}
      <section className="section-padding bg-background">
        <div className="container-wide mx-auto">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-16">
            {/* Info */}
            <div className="space-y-12">
              {/* Contact Methods */}
              <div>
                <h2 className="font-display text-2xl font-bold text-foreground mb-6">
                  Come contattarci
                </h2>
                <div className="space-y-4">
                  <a
                    href="mailto:taekwondomatteiroma@gmail.com"
                    className="flex items-center gap-4 p-4 rounded-xl bg-secondary hover:bg-secondary/80 transition-colors border border-gold/10"
                  >
                    <div className="w-12 h-12 rounded-full bg-gold/10 flex items-center justify-center flex-shrink-0">
                      <Mail className="h-6 w-6 text-gold" />
                    </div>
                    <div>
                      <h3 className="font-display text-lg font-semibold text-foreground">
                        Email
                      </h3>
                      <p className="font-body text-muted-foreground">taekwondomatteiroma@gmail.com</p>
                    </div>
                  </a>

                  <a
                    href="https://wa.me/393333346514"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="flex items-center gap-4 p-4 rounded-xl bg-secondary hover:bg-secondary/80 transition-colors border border-gold/10"
                  >
                    <div className="w-12 h-12 rounded-full bg-gold/10 flex items-center justify-center flex-shrink-0">
                      <Phone className="h-6 w-6 text-gold" />
                    </div>
                    <div>
                      <h3 className="font-display text-lg font-semibold text-foreground">
                        WhatsApp
                      </h3>
                      <p className="font-body text-muted-foreground">+39 333 334 6514</p>
                    </div>
                  </a>

                  <div className="flex items-center gap-4 p-4 rounded-xl bg-secondary border border-gold/10">
                    <div className="w-12 h-12 rounded-full bg-gold/10 flex items-center justify-center flex-shrink-0">
                      <MapPin className="h-6 w-6 text-gold" />
                    </div>
                    <div>
                      <h3 className="font-display text-lg font-semibold text-foreground">
                        Indirizzo
                      </h3>
                      <p className="font-body text-muted-foreground">
                        Via Marino Mazzacurati, 90 – 00148 Roma (RM)
                      </p>
                    </div>
                  </div>
                </div>
              </div>

              {/* Schedule */}
              <div>
                <h2 className="font-display text-2xl font-bold text-foreground mb-6">
                  <Clock className="inline-block h-6 w-6 mr-2 text-gold" />
                  Orari dei corsi
                </h2>
                <div className="card-elevated overflow-hidden border border-gold/20">
                  <table className="w-full">
                    <thead>
                      <tr className="border-b border-border">
                        <th className="py-3 px-4 font-body font-medium text-foreground text-left text-sm">Giorno</th>
                        <th className="py-3 px-4 font-body font-medium text-foreground text-center text-sm">Bambini/Ragazzi</th>
                        <th className="py-3 px-4 font-body font-medium text-foreground text-center text-sm">Adulti</th>
                      </tr>
                    </thead>
                    <tbody>
                      {orari.map((item, index) => (
                        <tr
                          key={item.giorno}
                          className={`${index !== orari.length - 1 ? 'border-b border-border' : ''}`}
                        >
                          <td className="py-3 px-4 font-body font-medium text-foreground text-sm">
                            {item.giorno}
                          </td>
                          <td className={`py-3 px-4 font-body text-center text-sm ${item.bambini === '—' || item.bambini === 'Chiuso' ? 'text-muted-foreground' : 'text-gold font-medium'}`}>
                            {item.bambini}
                          </td>
                          <td className={`py-3 px-4 font-body text-center text-sm ${item.adulti === '—' || item.adulti === 'Chiuso' ? 'text-muted-foreground' : 'text-gold font-medium'}`}>
                            {item.adulti}
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>

            {/* Map */}
            <div className="space-y-8">
              <div>
                <h2 className="font-display text-2xl font-bold text-foreground mb-6">
                  Dove siamo
                </h2>
                <div className="aspect-[4/3] rounded-2xl overflow-hidden shadow-large bg-muted">
                  <iframe
                    src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2971.5!2d12.3948!3d41.8367!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x13258a0c0e3e3c07%3A0x1!2sVia+Marino+Mazzacurati%2C+90%2C+00148+Roma+RM!5e0!3m2!1sit!2sit!4v1700000000000!5m2!1sit!2sit"
                    width="100%"
                    height="100%"
                    style={{ border: 0 }}
                    allowFullScreen
                    loading="lazy"
                    referrerPolicy="no-referrer-when-downgrade"
                    title="Mappa Taekwondo Mattei - Via Marino Mazzacurati 90, Roma"
                  />
                </div>
              </div>

              <div className="p-6 bg-secondary rounded-xl border border-gold/20">
                <h3 className="font-display text-lg font-semibold text-foreground mb-4">
                  Come raggiungerci
                </h3>
                <div className="space-y-4 font-body text-muted-foreground">
                  <div className="flex items-start gap-3">
                    <Bus className="h-5 w-5 text-gold flex-shrink-0 mt-0.5" />
                    <div>
                      <strong className="text-foreground">Bus:</strong> Linee 98, 889, 96, 786, 775 – Fermata Poggio Verde/Tabacchi (71018), 200 metri a piedi.
                    </div>
                  </div>
                  <div className="flex items-start gap-3">
                    <Train className="h-5 w-5 text-gold flex-shrink-0 mt-0.5" />
                    <div>
                      <strong className="text-foreground">Metro:</strong> Linea A Cornelia + 889, oppure Linea B Piramide + 96 o 775 fino a Poggio Verde/Tabacchi (71018).
                    </div>
                  </div>
                  <div className="flex items-start gap-3">
                    <Car className="h-5 w-5 text-gold flex-shrink-0 mt-0.5" />
                    <div>
                      <strong className="text-foreground">Auto:</strong> Ampio parcheggio di fronte alla palestra.
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="section-padding gradient-black">
        <div className="container-narrow mx-auto text-center">
          <h2 className="font-display text-3xl md:text-4xl font-bold text-gold mb-6">
            Pronto a iniziare?
          </h2>
          <p className="font-body text-lg text-gold/70 mb-8 max-w-xl mx-auto">
            Prenota la tua lezione di prova gratuita e vieni a conoscerci di persona.
          </p>
          <Link to="/lezione-di-prova" className="btn-accent text-lg">
            Prenota una lezione di prova
            <ArrowRight className="ml-2 h-5 w-5" />
          </Link>
        </div>
      </section>
    </Layout>
  );
};

export default Contatti;
